import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { c } from '../../utils';
import classes from './Loading.module.scss';

interface Props {
  className?: string;
  message?: string | React.ReactElement;
  overlay?: boolean;
  showProgressCircle?: boolean;
}

export function Loading({
  className,
  message,
  overlay,
  showProgressCircle = true,
  ...restProps
}: Props) {
  return (
    <div
      className={c(classes.Loading, overlay && classes.overlay, className)}
      {...restProps}
    >
      {showProgressCircle && <CircularProgress />}
      {message && <div className={classes.message}>{message}</div>}
    </div>
  );
}
